<template>
  <div>
    <div style="position: absolute;left: 20px;top: 10px;z-index: 999999"><Language/></div>
    <div class="page-wrapper">
      <div class="container-fluid p-0">
        <div class="row">
          <div class="col-12">
            <div class="login-card">
              <div>
                <div>
                    <a class="logo" target="_blank" href="https://www.gameofbusiness.eu/">
                        <img
                                class="img-fluid for-light"
                                src="../assets/images/logo/logo.png"
                                alt="looginpage"
                        />
                    </a>
                </div>
                <div class="login-main login-form-card">
                  <form class="theme-form" @submit.stop="">
                    <h4>{{$t("message.login_new_password")}}</h4>

                    <div class="form-group">
                      <label class="col-form-label">{{$t("message.register_email_label")}}</label>
                      <input v-validate.disable="'required|email'" v-model="email" class="form-control" type="email"
                             name="email"
                             placeholder="Test@gmail.com">
                      <span class="error-red mt-4" v-if="errors.first('email')">
                        {{$t("message.register_error_email")}}
                      </span>
                    </div>
                    <div class="form-group mb-0">
                      <button class="btn btn-primary btn-block" type="button" @click="onSubmit">{{$t("message.forgot_reset")}}</button>
                    </div>
                    <p class="mt-4 mb-0">{{$t("message.register_login_label")}}
                      <router-link class="ml-2" tag="a" to="/auth/login">
                        {{$t("message.register_login")}}
                      </router-link>
                    </p>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Language from "../components/header/language";

export default {
  components: {
    Language
  },
  data: function () {
    return {
      email: ""
    };
  },
  methods: {

    async onSubmit() {

      this.$validator.validate().then(valid => {

        if (valid) {

          this.$store.dispatch("shared/forgot", this.email).then((item) => {
            this.$router.push({name: 'Login'})
          })

        }
      })


    }
  }
};
</script>
